/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import {TASKS_SORTINGS} from '../../../common/constants';

const FiltersWrapper = styled.nav`
	display: none;
	& {
		ul {
			display: flex;
			margin: 0;
			list-style-type: none;
			align-items: center;
		}

		li {
			position: relative;
			background: transparent;

			&.current {
				button {
					color: #439dd5;
				}
			}

			button {
				text-decoration: none;
				color: #707078;
				font-size: 14px;
				font-weight: 500;
				background: transparent;
				padding: 0 7px;
				border: none;

				&.active,
				&:hover {
					color: #427feb;
				}
			}

			+ li {

				&:before {
					content: '|';
					font-size: 14px;
					color: #d9d7d7;
				}
			}
		}
	}
`;

const Sorting = ({currentSort, updateSorting}) => (
    <FiltersWrapper>
        <ul>
            {Object.entries(TASKS_SORTINGS).map(([sortKey, label]) => (
                <li className={`${currentSort === sortKey ? 'current' : ''}`} key={sortKey}>
                    <button onClick={() => updateSorting(sortKey)}>
                        {label}
                    </button>
                </li>
            ))}
        </ul>
    </FiltersWrapper>
);

export default Sorting;



// WEBPACK FOOTER //
// ./src/components/dashboard/bar/sorting.js